import * as DateFns from "date-fns";
import { z } from "zod";
import { hasValue } from "../services/formValidations";
import { REQUIRED_SHORT_VALIDATION_ERROR } from "../services/url/constants";
import { nullableWithDefault } from "../services/zodExtra";

export const emptyNameForm: NameFormType = {
  first_name: "",
  middle_name: "",
  last_name: "",
  birth_date: "",
};

export const NameSchema = z.object({
  first_name: nullableWithDefault(z.string().trim(), ""),
  middle_name: nullableWithDefault(z.string().trim(), ""),
  last_name: nullableWithDefault(z.string().trim(), ""),
  birth_date: nullableWithDefault(z.string().trim(), ""),
});

export const MIN_BIRTH_DATE = "1900-01-01";
export const MAX_BIRTH_DATE = "2200-12-31";

export const NameValidator = NameSchema.extend({
  first_name: NameSchema.shape.first_name.refine(
    hasValue,
    REQUIRED_SHORT_VALIDATION_ERROR
  ),
  last_name: NameSchema.shape.last_name.refine(
    hasValue,
    REQUIRED_SHORT_VALIDATION_ERROR
  ),
  birth_date: NameSchema.shape.birth_date
    .refine(hasValue, REQUIRED_SHORT_VALIDATION_ERROR)
    .refine(
      (value) => !DateFns.isBefore(value, MIN_BIRTH_DATE),
      `Date must be on or after ${MIN_BIRTH_DATE}`
    )
    .refine(
      (value) => !DateFns.isAfter(value, MAX_BIRTH_DATE),
      `Date must be on or before ${MAX_BIRTH_DATE}`
    ),
});

export type NameFormType = z.infer<typeof NameSchema>;
